module.exports = __webpack_public_path__ + "img/phone-icon.47086140.svg";